import React from "react";
import PageHeader from "../../components/PageHeader";
import NewsListComponent from "../../components/News/NewsList";

class NewsList extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="News"
                            Breadcrumb={[
                                { name: "News", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <NewsListComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewsList;
